/* eslint-disable no-unused-vars */
export enum Permission {
  STATUS = 1,
  MESSAGE = 1 << 1,
  CONFIGURATION = 1 << 2,
  TRACE = 1 << 3,
  TRACE_FOLLOW = 1 << 4,
  TRACE_BACK = 1 << 5,
  FOLLOW_LEADER = 1 << 6,
  TEAM_POSITION = 1 << 7,
  SWITCH_GRAMMAR = 1 << 8,
  LED_MATRIX = 1 << 9,
  ADMINISTRATION = 1 << 10,
  QR_CODE = 1 << 11,
  STOP = 1 << 12,
  REVERSE_TRACE = 1 << 13,
  SAVE_TRACE = 1 << 14,
  IMPORT_TRACE = 1 << 15,
  CREATE_TRACE = 1 << 16,
  MODIFY_LAYER = 1 << 17,
  SWITCH_LAYER = 1 << 18,
}

export const PERMISSION_LABELS: Record<FeaturePermission, string> = {
  STATUS: "Statut",
  MESSAGE: "Message",
  CONFIGURATION: "Configuration",
  TRACE: "Traçage",
  TRACE_FOLLOW: "Suivi de tracé",
  TRACE_BACK: "Retour sur tracé",
  FOLLOW_LEADER: "Suivre le chef",
  TEAM_POSITION: "Position équipe",
  SWITCH_GRAMMAR: "Changer la grammaire",
  LED_MATRIX: "Matrice led bouton",
  ADMINISTRATION: "gérer les users",
  QR_CODE: "générer des qr codes",
  STOP: "bouton stop",
  REVERSE_TRACE: "inverser la trace",
  SAVE_TRACE: "sauvegarder la trace",
  IMPORT_TRACE: "importer la trace",
  CREATE_TRACE: "créer une trace",
  MODIFY_LAYER: "modifier la couche",
  SWITCH_LAYER: "changer de vue",
};

export const ALL_PERMISSIONS = Object.keys(Permission).filter((k) => Number.isNaN(Number(k))) as FeaturePermission[];

export function permissionsFromBitmask(bitmask: number): FeaturePermission[] {
  return ALL_PERMISSIONS.filter((name) => (bitmask & Permission[name as keyof typeof Permission]) > 0);
}

export function bitmaskFromPermissions(permissions: FeaturePermission[]): number {
  return permissions.reduce((acc, name) => acc | Permission[name as keyof typeof Permission], 0);
}
